<template>
  <path pid="0" d="M2 14h10v6a4 4 0 008 0 1 1 0 00-.24-.65L15.17 14H24a1 1 0 001-1.1 12.06 12.06 0 00-24 0A1 1 0 002 14zm16 6.34a2 2 0 01-4-.34v-4.3zM13 4a10.05 10.05 0 019.84 8H3.16A10.05 10.05 0 0113 4z"/>
</template>
